import moment from "moment";

const useCurrentMonth = () => {

    const start = moment().startOf('month').format('YYYY-MM-DD')
    const end = moment().endOf('month').format('YYYY-MM-DD')

    return { start, end }

};

export default useCurrentMonth